import Vue from 'vue';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

Vue.use(Loading, {
    canCancel: true,
    isFullPage: true,
    loader: "dots",
    color: "#888",
})